///*eslint-disable jsx-a11y/aria-role */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Row,
  Container,
  Navbar,
  Nav,
  NavDropdown,
  OverlayTrigger,
  Popover,
  Col,
  Accordion,
  Card,
} from 'react-bootstrap';
import './header.scss';
import { useSelector, useDispatch } from 'react-redux';
import { HeaderSVG } from '../../img/GlobalSVG';
import MasterPermissions from '../../api/MasterPermissions';
import { useNavigate, useLocation, Link } from 'react-router-dom';
//import { Link } from 'react-router-dom';
import { logout } from '../../../redux/app/userSlice';
import { useTranslation } from 'react-i18next';
import { resetRecentSearchList } from '../../../redux/member/priceCompareSlice';
//import httpheader from 'src/Member/shared/httpheader';
//import TooltipNotificationIcon from '../../img/Notification-Bell.svg';
//import NotificationBell from '../../img/Bell-Notification.svg';
import { AccordionDownArrow } from 'src/Member/img/findcare/FindCareSVG';
import {
  ToolTipNotificationBellSVG,
  NotificationBellSVG,
} from '../../img/NotificationSVG';
import A1mLightLogo from '../../img/A1MLightLogo.svg';
import HelpCenterImage from '../../img/Help-Center.svg';
import NotificationPopup from '../Message&Documents/NotificationPopup';
import APIEndpoints from '../../../../src/Member/api/APIEndpoints'; //getNotificationcountapi
import { axiosInstance } from '../../../../src/api/axios';
import Avatar from '../common/avatar-with-initials';
import PortalName from './PortalName';
import { arrayBufferToBase64 } from 'src/Member/utils/common';

export default function SecureHeader({
  getNotificationCount,
  setGetNotificationCount,
}) {
  const { t } = useTranslation();
  const { isLogoLoaded, logoImage, logoType } = useSelector(
    (state) => state.theme,
  );
  const { isLoggedIn, userData } = useSelector((state) => state.user);
  const { ClientLogoConfig } =
    useSelector((state) => state.app.appConfigs) || [];
  const clientID = userData.MemberDetails.ClientID;
  const [isMenuDisabled, setMenuDisabled] = useState(false);
  //const [notificationCount, setNotificationCount] = useState('9');
  const [activeId, setActiveId] = useState(0);
  const [showNotificationBody, setShowNotificationBody] = useState('0');
  const [showNotification, setShowNotification] = useState(true);
  //const [getNotificationCount, setGetNotificationCount] = useState([]);
  const [messageDetails, setMessageDetails] = useState([]);
  const [showAdditionalLogo, setShowAdditionalLogo] = useState(false);
  const [additioanlLogo, setAdditioanlLogo] = useState('');
  const [additionalLogoType, setAdditionalLogoType] = useState('');
  const notificationCount = '9';
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logoutAction = () => {
    dispatch(logout({ preserveBearerToken: true }));
    dispatch(resetRecentSearchList());
    navigate('/member/logout');
    console.log('Member secure Logout -> isAuthenticated: ');
  };

  //copied
  useEffect(() => {
    if (
      location.pathname.includes('/member/page/') &&
      location.search.includes('&newTab')
    ) {
      setMenuDisabled(true);
    } else {
      setMenuDisabled(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (isLoggedIn) {
      const logoData = ClientLogoConfig.filter(
        (eachClientInfo) => eachClientInfo.ClientID == clientID,
      );
      if (logoData?.length > 0 && logoData[0].ClientLogoID !== '') {
        getAdditionalLogo(logoData[0].ClientLogoID);
      }
    }
  }, [isLoggedIn]);

  const getAdditionalLogo = async (additionalLogoOID) => {
    try {
      const logoImageData = await axiosInstance.get(
        APIEndpoints.getLogo() + additionalLogoOID,
        {
          responseType: 'arraybuffer',
        },
      );
      setShowAdditionalLogo(true);
      setAdditionalLogoType(logoImageData.headers['content-type']);
      setAdditioanlLogo(arrayBufferToBase64(logoImageData.data));
    } catch (error) {
      return error;
    }
  };

  //getNotificationcountapi
  const notificationCountList = async () => {
    try {
      const responseNotification = await axiosInstance.get(
        APIEndpoints.getNotificationcountapi(),
      );
      const MessageCounts =
        responseNotification.data.Response.ResponseObectForNotification
          .MessageCount;
      const MessageDetails =
        responseNotification.data.Response.ResponseObectForNotification
          .MessageDetail;
      setGetNotificationCount(MessageCounts);
      setMessageDetails(MessageDetails);
    } catch (error) {
      return;
    }
  };

  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };

  const notificationShowHideHandler = () => {
    if (showNotification == false) {
      setShowNotification(true);
      setShowNotificationBody(null);
    } else {
      setShowNotification(!showNotification);
      setShowNotificationBody('0');
    }
  };

  const closeNotificationHandler = () => {
    setShowNotification(false);
  };

  //copied
  useEffect(() => {
    setShowNotificationBody('0');
    if (location.pathname.includes('/member/dashboard')) {
      setShowNotification(true);
    } else {
      setShowNotification(false);
    }
  }, [location.pathname]);

  //copied
  useEffect(() => {
    notificationCountList();
  }, []);

  return (
    <div className="topHeader">
      <Container>
        <Row>
          <div
            className={`col-sm-6 d-flex col-xs-12 ${
              !isMenuDisabled ? 'logo-container' : ''
            }`}
          >
            {!isMenuDisabled && (
              <Link to="/member/dashboard">
                {isLogoLoaded && (
                  <img
                    src={'data:' + logoType + ';base64, ' + logoImage}
                    alt="Company Logo"
                  />
                )}
              </Link>
            )}
            {isMenuDisabled && (
              <>
                {isLogoLoaded && (
                  <img
                    src={'data:' + logoType + ';base64, ' + logoImage}
                    alt="Company Logo"
                  />
                )}
                {!isLogoLoaded && logoType === null && (
                  <img src={A1mLightLogo} alt="Company Logo" />
                )}
              </>
            )}
            {showAdditionalLogo && (
              <img
                className="additional-logo"
                src={
                  'data:' + additionalLogoType + ';base64, ' + additioanlLogo
                }
                alt="Prime Logo"
              />
            )}
          </div>

          <Col
            md={6}
            className="d-none d-md-flex justify-content-end m-auto header-portal-name-container"
          >
            <PortalName
              isSecure={true}
              getNotificationCount={getNotificationCount}
              setGetNotificationCount={setGetNotificationCount}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
